// extracted by mini-css-extract-plugin
module.exports = {"form":"_1QKgR6VP8S9Bvy9_fwuHNe"};